module.exports = __webpack_public_path__ + "img/calendar-9.08ee3a69.svg";